import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["SuspendedSitePage"] */ "/workspace/src/components/mini-site-templates/SuspendedSitePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Template1Renderer"] */ "/workspace/src/components/mini-site-templates/template1/Template1Renderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Template2Renderer"] */ "/workspace/src/components/mini-site-templates/template2/Template2Renderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Template3Renderer"] */ "/workspace/src/components/mini-site-templates/template3/Template3Renderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Template4Renderer"] */ "/workspace/src/components/mini-site-templates/template4/Template4Renderer.tsx");
